import EXIF from 'exif-js';

(() => {
  angular.module('pims').directive('file', ["Media", Media => {
    'ngInject';

    return {
      restrict: 'A',
      priority: 999,
      scope: {
        file: '=',
      },
      link(scope, element, attrs) {

        const render = (imagePath, orientation) => {

          if (attrs.hasOwnProperty('setBackground')) {
            element.css('background-image', `url(${imagePath})`);
          } else {
            element.attr('src', imagePath);
          }

          switch(orientation) {
            case 1:
              // horizontal (normal)
              break;
            case 2:
              // horizontal flip
              break;
            case 3:
              // 180° rotate left
              element.css({
                transform: `rotate(180deg)`,
              });
              break;
            case 4:
              // vertical flip
              break;
            case 5:
              // vertical flip + 90 rotate right
              break;
            case 6:
              // 90° rotate right
              element.css({
                transform: `rotate(90deg)`,
              });
              break;
            case 7:
              // horizontal flip + 90 rotate right
              break;
            case 8:
              // 90° rotate left
              element.css({
                transform: `rotate(270deg)`,
              });
              break;
          }

        };

        const getParsedFile = (file) => {
          if (!file.file_id && !file.file) {
            return null;
          }
          const parsedFile = {
            id: file.file_id ? file.file_id : file.file.id,
            deleted: file.file.deleted,
            image_uri: file.file_id ? file.image_uri : file.file.image_uri,
          };
          return parsedFile;
        }

        const download = (file) => {
          file = getParsedFile(file);
          if (!file || (!file.id && !file.image_uri) || file.deleted) {
            return render('assets/images/noimage.png', 0);
          }

          render('assets/images/loading-3.gif', 0);

          if (file.image_uri) {

            render(file.image_uri, 0);

          } else {
            return Media.getFile(file.id)
            .then(({ data, headers }) => {

              // can eventually deprecate when the BE is in and confirmed working.
              if (!data.size || data.deleted) {
                render('assets/images/noimage.png');
              } else {

                var newBlob = new Blob([data,], { type: headers('content-type') });
                const reader = new FileReader();

                reader.onload = event => {

                  var dataURL = event.target.result;
                  render(dataURL, 0);
                }

                reader.readAsDataURL(newBlob);
              }
            })
            .catch(() => {
              render('assets/images/noimage.png')
            });
          }
        };

        scope.$watch('file', (newFile) => {
          if (newFile) {
            download(newFile);
          }
        });

        /**
         * TODO: TP: figure out why the above watch doesn't see the
         * deleted prop change in delete button flow
         *
         * see: task-photos-old.component.js#deletePhoto -> file.deleted
          */
        scope.$watch('file.deleted', (newFile) => {
          if (newFile) {
            download(newFile);
          }
        });
      },
    };
  }])
})();
